import { UserModel } from "./UserModel";

/**
 * * Модель администратора
 */
export class AdminModel extends UserModel {
  /**Возможность формировать очередность */
  CanCustomizeOrder: boolean = false;

  constructor(obj?: Partial<AdminModel>) {
    super(obj);
    Object.assign(this, obj);
  }
}
